import { StackNavigationOptions } from "@react-navigation/stack";

const screenOptions: StackNavigationOptions = {
  headerShown: false,
};

export default screenOptions;
